// IP 归属地查询：供首次访问的默认语言决策使用（国内中文 / 国外英文）
// 设计约束：
// - 只读 country_code，响应按数据处理，不做任何渲染
// - 双免费源（ipwho.is / geojs.io）并发请求，互为备份；单个源 2 秒超时
// - 任何失败（超时/被墙/返回异常）返回 null，调用方默认保持中文
// - 结果缓存于 sessionStorage，整会话只查一次，避免每次刷新都阻塞首屏

const GEO_TIMEOUT_MS = 2000;
const STORAGE_KEY = 'portal-geo-country';

// 安全读取国家码：仅接受两位字母，其余一律视为无效
function extractCountry(data) {
  const code = data && (data.country_code || data.country);
  return typeof code === 'string' && /^[A-Za-z]{2}$/.test(code) ? code.toUpperCase() : null;
}

async function fetchJsonWithTimeout(url, timeoutMs) {
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
  const timer = controller ? setTimeout(() => controller.abort(), timeoutMs) : null;
  try {
    const res = await fetch(url, controller ? { signal: controller.signal } : undefined);
    if (!res.ok) return null;
    return await res.json();
  } catch (e) {
    return null;
  } finally {
    if (timer) clearTimeout(timer);
  }
}

function readCachedCountry() {
  try {
    const cached = sessionStorage.getItem(STORAGE_KEY);
    return /^[A-Za-z]{2}$/.test(cached || '') ? cached.toUpperCase() : null;
  } catch (e) {
    return null;
  }
}

function writeCachedCountry(code) {
  try {
    sessionStorage.setItem(STORAGE_KEY, code);
  } catch (e) {
    /* 隐私模式下 sessionStorage 可能不可用，忽略 */
  }
}

let inflight = null;

// 返回 Promise<string|null>：两位国家码（如 'CN'、'US'），失败为 null
export function detectCountryCode() {
  const cached = readCachedCountry();
  if (cached) return Promise.resolve(cached);

  if (!inflight) {
    inflight = (async () => {
      // 双源并发，主源（ipwho.is）优先，主源失败取备源结果
      const [primary, backup] = await Promise.all([
        fetchJsonWithTimeout('https://ipwho.is/', GEO_TIMEOUT_MS),
        fetchJsonWithTimeout('https://get.geojs.io/v1/ip/country.json', GEO_TIMEOUT_MS)
      ]);
      const code = extractCountry(primary) || extractCountry(backup);
      if (code) writeCachedCountry(code);
      return code;
    })();
  }
  return inflight;
}
